
<suffix :size="70" :class="{vertical: verticalOrientation, horizontal: !verticalOrientation}">
  <slot-array :length="3">
    <template :slot="downPosition" v-if="!hideMoveControls">
      <button :disabled="disabled || (!disabled && card.isLast)" @click.prevent.stop="card.moveDown" :id="`moveDown_${card.client_id}`" class="btn-icon clear-area">
        <icon :class="`arrow-chevron ${downWord}`"></icon>
        <span class="sr-only">Move {{card.displayName}} one step {{downWord}}</span>
      </button>
    </template>
    <template :slot="upPosition"  v-if="!hideMoveControls">
      <button :disabled="disabled || (!disabled && card.isFirst)" @click.prevent.stop="card.moveUp" :id="`moveUp_${card.client_id}`" class="btn-icon clear-area">
        <icon :class="`arrow-chevron ${upWord}`"></icon>
        <span class="sr-only">Move {{card.displayName}} one step {{upWord}}</span>
      </button>
    </template>
    <template :slot="3">
      <button
        @click.stop="remove"
        class="btn-icon clear-to-red close"
        :class="{disabled: disabled || !removeEnabled}"
        :aria-disabled="disabled || !removeEnabled"
        v-tooltip="removeTooltip"
      >
        <icon class="times"></icon>
        <span class="sr-only">Delete {{card.displayName}}</span>
      </button>
    </template>
  </slot-array>
</suffix>
